// @flow
import { all, call, fork, takeEvery } from 'redux-saga/effects';
import types from './actionTypes';

/**
 * Changes the body attribute
 */
function changeBodyAttribute(attribute, value) {
  if (document.body) document.body.setAttribute(attribute, value);
  return true;
}

/**
 * Toggle the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = 'toggle') {
  switch (action) {
    case 'add':
      if (document.body) document.body.classList.add(cssClass);
      break;
    case 'remove':
      if (document.body) document.body.classList.remove(cssClass);
      break;
    default:
      if (document.body) document.body.classList.toggle(cssClass);
      break;
  }

  return true;
}

/**
 * Changes the layout width
 * @param {*} param0
 */
function* changeLayoutWidth({ payload: width }) {
  try {
    yield call(changeBodyAttribute, 'data-layout-size', width);
  } catch (error) {}
}

/**
 * Changes the left sidebar theme
 * @param {*} param0
 */
function* changeLeftSidebarTheme({ payload: theme }) {
  try {
    yield call(changeBodyAttribute, 'data-sidebar', theme);
  } catch (error) {}
}

/**
 * Changes the topbar theme
 * @param {*} param0
 */
function* changeTopbarTheme({ payload: theme }) {
  try {
    yield call(changeBodyAttribute, 'data-topbar', theme);
  } catch (error) {}
}

/**
 * Changes the left sidebar type
 * @param {*} param0
 */
function* changeLeftSidebarType({ payload: { sidebarType, isMobile } }) {
  try {
    switch (sidebarType) {
      case 'condensed':
        yield call(manageBodyClass, 'sidebar-enable', 'add');
        // On mobile `sidebar-enable` opens the off-canvas menu, and the
        // icon-only collapsed mode would lay it over the page content
        yield call(
          manageBodyClass,
          'vertical-collpsed',
          isMobile ? 'remove' : 'add',
        );
        break;
      default:
        yield call(manageBodyClass, 'sidebar-enable', 'remove');
        yield call(manageBodyClass, 'vertical-collpsed', 'remove');
        break;
    }
  } catch (error) {}
}

/**
 * Opens or closes the off-canvas sidebar shown below the mobile breakpoint
 * @param {*} param0
 */
function* showSidebar({ payload: isOpen }) {
  try {
    yield call(manageBodyClass, 'sidebar-enable', isOpen ? 'add' : 'remove');
  } catch (error) {}
}

/**
 * Watchers
 */
export function* watchChangeLayoutWidth() {
  yield takeEvery(types.CHANGE_LAYOUT_WIDTH, changeLayoutWidth);
}

export function* watchChangeLeftSidebarTheme() {
  yield takeEvery(types.CHANGE_SIDEBAR_THEME, changeLeftSidebarTheme);
}

export function* watchChangeLeftSidebarType() {
  yield takeEvery(types.CHANGE_SIDEBAR_TYPE, changeLeftSidebarType);
}

export function* watchChangeTopbarTheme() {
  yield takeEvery(types.CHANGE_TOPBAR_THEME, changeTopbarTheme);
}

export function* watchShowSidebar() {
  yield takeEvery(types.SHOW_SIDEBAR, showSidebar);
}

function* LayoutSaga() {
  yield all([
    fork(watchChangeLayoutWidth),
    fork(watchChangeLeftSidebarTheme),
    fork(watchChangeLeftSidebarType),
    fork(watchChangeTopbarTheme),
    fork(watchShowSidebar),
  ]);
}

export default LayoutSaga;
